module.exports = __webpack_public_path__ + "1ea3eb51a29ea27a6e6e509a77f2c241.svg";